<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* @import './styles/public.css'; */
@import  './assets/css/common.css';
html,body,#app,.el-container{

/*设置内部填充为0，几个布局元素之间没有间距*/

 padding: 0px;

/*外部间距也是如此设置*/

margin: 0px;

/*统一设置高度为100%*/

height: 100%;

}

</style>



// WEBPACK FOOTER //
// src/App.vue